import React, {useContext, useEffect, useState} from 'react'
import AppContext from '../../ctx'
import Lottie from 'react-lottie'

import * as animationData from './lotties/dots.json'

import './style.scss'

const Splash = ({ override }) => {
    const ctx = useContext(AppContext)
    const { splash } = ctx.overlays

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData
    }

    const [startText, setStartText] = useState(null);

    useEffect(() => {
        const root = document.documentElement;
        let attempts = 0;

        const updateText = () => {
            const textValue = getComputedStyle(root)
                .getPropertyValue('--startText')
                .trim();
            const cleanText = textValue.replace(/^["']|["']$/g, '');

            if (cleanText) {
                setStartText(cleanText);
            } else if (attempts < 5) {
                attempts++;
                setTimeout(updateText, 50);
            }
        };

        updateText();
    }, []);

    return  <div className={`splash ${splash && splash.state ? '' : 'gone'}`}>
                {override ? (
                    <video muted loop autoPlay playsInline id="override-video" src={override} width='100%' />
                ) : null}

                <div className='brand'>
                    <div className='brand-img'></div>
                    <div className="brand__starttext">{startText || "Пожалуйста подождите, трансляция скоро начнется..."}</div>
                </div>

                {/*<Lottie options={defaultOptions} width='30vw' className='lottie' />*/}
            </div>
}

export default Splash
